import {AfterViewInit, Component, ContentChildren, ElementRef, EventEmitter, Input, Output, QueryList} from '@angular/core';
import {TdoAccordionItemComponent} from './tdo-accordion-item/tdo-accordion-item.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-tdo-accordion',
  templateUrl: './tdo-accordion.component.html',
  styleUrls: ['./tdo-accordion.component.scss']
})
export class TdoAccordionComponent implements AfterViewInit {

  @ContentChildren(TdoAccordionItemComponent) items: QueryList<TdoAccordionItemComponent>;

  @Input() allowMultiple: boolean = true;
  @Input() autoOpenFirst: boolean = false;
  @Output() childItemsUpdate = new EventEmitter<TdoAccordionItemComponent[]>();

  subscriptions: Subscription[] = new Array<Subscription>(); 

  constructor(public elRef: ElementRef) { }

  ngAfterViewInit(): void {
    if (this.items && this.items.length > 0) {
      for (const item of this.items) {
        this.subscriptions.push( 
          item.opened.subscribe((it) => {
          this.onChildExpanded(it);
        })
      );
      }
      
      this.items.changes.subscribe(() => {
        while(this.subscriptions.length > 0)
          this.subscriptions.pop().unsubscribe();
        for (const item of this.items.toArray()) {
          item.isExpanded = false;
          this.subscriptions.push( 
          item.opened.subscribe((it) => {
            this.onChildExpanded(it);
          })
          );
        }
        this.childItemsUpdate.emit(this.items.toArray());
      });
    }
  }

  onChildExpanded(item: TdoAccordionItemComponent) {
    for (const it of this.items) {
      if (it !== item) {
        it.isExpanded = false;
      }
    }
  }
}
